import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from 'app/store';
import { GatewayInfo } from 'models/gateway';

export interface GatewayState {
  loading: boolean;
  currentGateway?: GatewayInfo;
  error?: string;
}

const initialState: GatewayState = {
  loading: false,
  currentGateway: undefined,
  error: undefined,
};

const gatewaySlice = createSlice({
    name: 'gateway',
    initialState,
    reducers: {
      fetchGatewayInfo(state, action: PayloadAction<GatewayInfo>) {
        state.loading = true;
      },
      fetchGatewayInfoSuccess(state, action: PayloadAction<GatewayInfo>) {
        state.loading = false;
        state.currentGateway = action.payload;
      },
      fetchGatewayInfoFailed(state, action: PayloadAction<string>) {
        state.loading = false;
        state.error = action.payload;
      },
    },
  });
  
  export const gatewayActions = gatewaySlice.actions;
  
  export const selectGatewayError = (state: RootState) => state.gatewayReducer.error;
  export const selectLoading = (state: RootState) => state.gatewayReducer.loading;
  export const selectGatewayInfo = (state: RootState) => state.gatewayReducer.currentGateway;
  
  const gatewayReducer = gatewaySlice.reducer;
  export default gatewayReducer;